"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const model_1 = require("../../model");
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const OutlinedInput_1 = __importDefault(require("@mui/material/OutlinedInput"));
/**
 * Parse HitTypes
 */
function parseHitTypes(value) {
    const types = [];
    for (const element of value.split(",")) {
        const numericElement = Number(element);
        if ((0, model_1.isHitType)((0, model_1.isHitType)(numericElement))) {
            types.push(numericElement);
        }
    }
    return types;
}
function HitTypeSelect(props) {
    const { types, onChange, className } = props;
    const handleChange = (0, react_1.useCallback)((event) => {
        const value = event.target.value;
        if (typeof value === "string") {
            onChange(parseHitTypes(value));
        }
        else {
            onChange(value);
        }
    }, [types, onChange]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(FormControl_1.default, { fullWidth: true },
            react_1.default.createElement(InputLabel_1.default, { id: "hit-type-select-label" }, "\u0422\u0438\u043F"),
            react_1.default.createElement(Select_1.default, { labelId: "hit-type-select-label", multiple: true, value: types, onChange: handleChange, input: react_1.default.createElement(OutlinedInput_1.default, { label: "\u0422\u0438\u043F" }), renderValue: (selected) => selected.map(model_1.hitTypeText).join(", ") }, model_1.hitTypes.map((type) => (react_1.default.createElement(MenuItem_1.default, { key: type, value: type },
                react_1.default.createElement(Checkbox_1.default, { checked: types.includes(type) }),
                react_1.default.createElement(ListItemText_1.default, { primary: (0, model_1.hitTypeText)(type) }))))))));
}
exports.default = HitTypeSelect;
